import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})
export class OffBalanceAccountService extends BaseRestService {

  readonly OFF_BALANCE_ACCOUNT_URL: string = environment.apiUri + '/off-balance-account';

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.OFF_BALANCE_ACCOUNT_URL, options);
  }

  create(account): Observable<any> {
    return this.httpClient.post(this.OFF_BALANCE_ACCOUNT_URL, JSON.stringify(account),
      { headers: this.headers });
  }

  getByAccountId(accountId): Observable<any> {
    const options = {
      headers: this.headers
    }
    return this.httpClient.get(this.OFF_BALANCE_ACCOUNT_URL + '/' + accountId, options);
  }

  getByAccountNumber(accountNumber): Observable<any> {
    const options = {
      headers: this.headers
    }
    return this.httpClient.get(this.OFF_BALANCE_ACCOUNT_URL + '/account-number?accountNumber=' + accountNumber, options);
  }

  getByCustomerId(id): Observable<any> {
    return this.httpClient.get(this.OFF_BALANCE_ACCOUNT_URL + '/customer/' + id, { headers: this.headers });
  }

  update(id: string, account): Observable<any> {
    return this.httpClient.put(this.OFF_BALANCE_ACCOUNT_URL + "/" + id, JSON.stringify(account),
      { headers: this.headers });
  }

  close(id): Observable<any> {
    return this.httpClient.put(this.OFF_BALANCE_ACCOUNT_URL + '/close/' + id,
      { headers: this.headers });
  }

  reopen(data): Observable<any> {
    return this.httpClient.put(this.OFF_BALANCE_ACCOUNT_URL + "/reopen", JSON.stringify(data),
      { headers: this.headers });
  }

  reopenById(id): Observable<any> {
    return this.httpClient.put(this.OFF_BALANCE_ACCOUNT_URL + "/reopen/" + id,
      { headers: this.headers });
  }

}
